<template>
  <div class="hello">
     <div class="ps-page--my-account">
        <!--<div class="ps-breadcrumb">
            <div class="container">

            </div>
        </div>-->
        <div class="ps-my-account">
            <div class="container">
                <form class="ps-form--account ps-tab-root" @submit.prevent="loginToAccount">
                    <ul class="ps-tab-list">

                    </ul>
                    <div class="ps-tabs">
                        <div class="ps-tab active">
                             <div  v-if="failed" class="alert alert-danger" role="alert">
                                {{ msg }}
                            </div>

                               <div v-if="sent" class="loading">
                                 <div class="spinner-border" role="status">
                                 </div>
                                 <span class="visually-hidden">Loading...</span>
                               </div>

                            <div class="ps-form__content">
                                <h5>Log In Your Account</h5>
                                <div class="form-group">
                                    <input class="form-control"
                                    type="text"
                                    placeholder="Email address"
                                    required
                                    v-model="user.email"
                                    >
                                </div>
                                <div class="form-group form-forgot">
                                    <input class="form-control"
                                    type="password"
                                    placeholder="Password"
                                    required
                                    v-model="user.password">
                                     <router-link to="/forgot-password" >Forgot?</router-link>
                                </div>
                                <div class="form-group">
                                    <div class="ps-checkbox">
                                        <input class="form-control" type="checkbox" id="remember-me" name="remember-me">
                                        <label for="remember-me">Rememeber me</label>
                                    </div>
                                </div>
                                <div class="form-group submit">
                                    <button @click="loginToAccount" :disabled="clicked" class="ps-btn ps-btn--fullwidth">Login</button>
                                </div>
                            </div>
                            <!--<div class="ps-form__footer">

                            </div>-->
                        </div>

                    </div>
                </form>
               <div class="logo-visitor"><a href="https://entreproamd.com/" target="_blank"><img src="../assets/img/logo-entreproamd.png" alt="Entreproamd Logo"></a></div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
export default {
  name: 'Login',
    data() {
    return {
      clicked: false,
      failed : false,
      sent : false,
      msg: "",
      user: {
        email: "",
        password: ""
      },
      languages :[{id:1,language:"English", href:"./assets/img/flag/en.png"},{id:2,language:"Français", href:"./assets/img/flag/fr.png"}],
    };
  },
    methods: {

    loginToAccount() {
      var data = {
        email: this.user.email,
        password: this.user.password
      };

      console.log(data);
      this.failed = false;
      this.clicked = true;
      this.sent = true;

      DataService.login_post(data)
        .then(response => {
           console.log(response.data)
           localStorage.setItem('email', this.user.email);
           this. user= { email: "", password: ""};
           this.sent = false;
           this.$parent.token = response.data.token;
           localStorage.setItem('token', response.data.token);
           this.$parent.company = response.data.company;
           localStorage.setItem('lang', response.data.language);

           if(response.data.language=='en'){

                this.$parent.language = this.languages[0];

           }else if(response.data.language=='fr'){

                this.$parent.language = this.languages[1];
           };

           localStorage.setItem('company', response.data.company);
           localStorage.setItem('caller_role', response.data.caller_role);
           this.$parent.caller_role = response.data.caller_role;
           this.$emit("giveway",true);

           if(response.data.caller_role=='Basic'){
              this.$router.push('/products');
           }else if(response.data.caller_role=="Admin" || response.data.caller_role=="Super"){
              this.$router.push('/private');
           }

        })
        .catch(e => {
          console.log(e);
          this.sent = false;

          if(e!=undefined){

           if(e.response.status == 404){

            this.msg = "Route nod found";
          }else if(e.response.status == 500){
            this.msg = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
            this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
            this.msg = "Please check your internet.";
          }
          this.failed = true;

          }

        });

        setTimeout(function(){
        this.clicked = false;
       }.bind(this),1000);
    },
},
   created(){
        this.$parent.token = "";
        this.$parent.company = "";
        this.$emit("giveway",false);
        this.$parent.loggedin = false;
        this.$emit("headerAndFooter",false);
    },

  mounted(){

        localStorage.setItem('token', '');
        localStorage.setItem('email', '');
        localStorage.setItem('caller_role', '');
        localStorage.setItem('company', '');
        localStorage.setItem('lang', '');

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .alert.alert-danger {
    margin-bottom: 0;
  }
  .form-group.submit {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue